import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, message } from 'antd';
import { Input } from 'components';
import { addOptOut } from 'services/blacklist.service';
import { customMessages, customValidators } from 'utils';
import NewContact from 'assests/icons/new-contact.icon';
import InputGSM from 'components/input/input-gsm';

const AddNewModal = (props) => {
  const [addRowModal, setAddRowModal] = useState(false);
  const [form] = Form.useForm();
  const [valid, setValid] = useState(false);

  const onValuesChange = () => {
    setTimeout(() => {
      let inputs = form.getFieldsError();

      for (var i = 0; i < inputs.length; i++) {
        let formItemName = inputs[i]['name'][0];
        if (checkError(formItemName)) {
          setValid(true);
        } else {
          setValid(false);
          break;
        }
      }
    }, 10);
  };

  const checkError = (fieldName) => {
    if (
      form.isFieldTouched(fieldName) &&
      form.getFieldError(fieldName).length === 0
    ) {
      return true;
    }
  };

  const onCloseModal = () => {
    form.resetFields();
    setAddRowModal(false);
  };

  const onSuccessModal = () => {
    props.onSuccess();
    setAddRowModal(false);
    form.resetFields();
  };

  function onAddOptOut(data) {
    addOptOut({ ids: data })
      .then((result) => {
        onSuccessModal();
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  useEffect(() => {
    if (!addRowModal) {
      form.resetFields();
    }
  }, [addRowModal]);

  return (
    <React.Fragment>
      <button
        onClick={() => {
          setAddRowModal(true);
        }}
        type="button"
      >
        <NewContact />
        <span>Yeni Kişi</span>
      </button>
      <Modal
        title="Kişi Ekle"
        visible={addRowModal}
        onCancel={() => onCloseModal()}
        footer={null}
      >
        <Form
          form={form}
          name="add-row"
          onValuesChange={onValuesChange}
          onFinish={(values) => {
            onAddOptOut([values.msisdn]);
          }}
        >
          <InputGSM label='Telefon Numarası'  />
          <div className="modal-action">
            <Button shape="round" type="ghost" onClick={() => onCloseModal()}>
              Vazgeç
            </Button>
            <Button key="confirm" type="primary" htmlType="submit" disabled={!valid}>
              Kaydet
            </Button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default AddNewModal;
